import { request } from 'service/api/common';
import * as apiUrl from './apiUrl';

// [공통]
export const getCodes = async (type: string) => {
  const { data } = await request(type === 'solution' ? 'auth' : 'd2').get(apiUrl.codes.detail(type));
  return data;
};
